let handlers = [];

export default function setupScrollWatch(){
    let handler = function() {
        for(let handle of handlers){

            if(handle.started){
                continue;
            }

            let element = handle.element ?? document.getElementById(handle.elementId);
            if(element){
                let y = element.getBoundingClientRect().y
                if(y > 5 && y < window.innerHeight - 5){
                    handle['started'] = true;
                    try{
                        handle.action();
                    } catch (e){
                        console.error(e);
                    }
                }
            }
        }
    };
    window.addEventListener('scroll', handler);
    window.addEventListener('resize', handler);
    window.addEventListener('DOMContentLoaded', handler);

    window['onScrollTo'] = onScrollTo;
    window['onScrollToEl'] = onScrollToEl;
    window['bounceOnScrollTo'] = bounceOnScrollTo;
}


function onScrollTo(elementId, action){
    handlers.push({
        'elementId':elementId, 'action':action, started:false
    });
}
function onScrollToEl(element, action){
    handlers.push({
        'element':element, 'action':action, started:false
    });
}

function bounceOnScrollTo(scrollElementId, bounceElementId, opts = {}) {
    onScrollTo("goto-plan2-btn", function () {

        console.log("Bounce goto-plan2-btn\"!");
        let animated = document.createElement("i");
        animated.style.setProperty("--fa-secondary-opacity", "0.1");
        animated.style.setProperty("--fa-animation-delay", opts?.delay ?? "3s");
        animated.style.setProperty("--fa-animation-iteration-count", "7");

        animated.dataset.faTransform = opts?.transform ?? "up-1 left-3";

        animated.classList.add('fa-duotone');
        animated.classList.add('fa-circle-check');
        animated.classList.add('fa-lg');
        animated.classList.add('fa-bounce');

        let el = document.getElementById(bounceElementId);
        el.parentNode.replaceChild(animated, el);
    });
}
